import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import React from "react";

const DiscardPreferenceModal = ({
  onCancel,
  confirmCancel,
  showDiscardModal,
}) => {
  return (
    <ConfirmModal
      confirmText="Discard"
      title="Discard changes"
      show={showDiscardModal}
      onConfirm={confirmCancel}
      onCancel={onCancel}
      confirmButtonProps={{
        variant: "contained",
        style: { color: "#fff", backgroundColor: "#EF5350" },
      }}
    >
      All the changes will be lost. Are you sure you want to discard the
      changes?
    </ConfirmModal>
  );
};

export default DiscardPreferenceModal;
